import http from "@/shared/api/http";

function buildCommercialOfferParams(options = {}) {
  return {
    clientName: options.clientName?.trim() || undefined,
    clientPhone: options.clientPhone?.trim() || undefined,
  };
}

export async function generateCommercialOfferPdf(cartId, options = {}) {
  return await http.get(`CommercialOffer/cart/${cartId}`, {
    params: buildCommercialOfferParams(options),
    responseType: "blob",
  });
}

export async function generateOrderCommercialOfferPdf(orderId, options = {}) {
  return await http.get(`CommercialOffer/order/${orderId}`, {
    params: buildCommercialOfferParams(options),
    responseType: "blob",
  });
}

export async function generateInternalOrderCommercialOfferPdf(orderId) {
  return await http.get(`CommercialOffer/order/${orderId}/internal`, {
    responseType: "blob",
  });
}
